import styled from 'styled-components'
import { breakpoints } from '../../constants'

export const StyledIcon = styled.div`
	flex-grow: 1;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		flex-grow: unset;
		width: 50px;
		height: 35px;
	}

	img {
		width: 100%;
		height: auto;
	}
`
